import { sendVerificationLinkUseCase } from '@identity/application/use-cases';
import type { ICredentialSourcePort } from '@identity/application/ports';
import type { LinkUseCases } from '@identity/composition/types';
import type { IdentityFlow, RequestAuthorizer } from '@identity/domain/types';
import type { AuthHttpClientType } from '@identity/infrastructure/api';
import { createAuthApiRepository } from '@identity/infrastructure/repositories';

/** Creates the magic link use cases a flow can run with the credential of its slice. */
export const createLinkUseCases = (
  httpClient: AuthHttpClientType,
  credentials: ICredentialSourcePort,
  flow: IdentityFlow,
  authorizer: RequestAuthorizer,
): LinkUseCases => {
  const repository = createAuthApiRepository({ httpClient, authorizer });

  return {
    sendVerificationLink: sendVerificationLinkUseCase(repository, credentials, flow),
  };
};
